var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14C9.448 14 9 14.448 9 15C9 15.552 9.448 16 10 16C10.552 16 11 15.552 11 15C11 14.448 10.552 14 10 14Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C11.103 13 12 13.897 12 15C12 16.103 11.103 17 10 17C8.897 17 8 16.103 8 15C8 13.897 8.897 13 10 13ZM10 12C8.343 12 7 13.3435 7 15C7 16.657 8.343 18 10 18C11.6565 18 13 16.657 13 15C13 13.343 11.6565 12 10 12Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C12.757 10 15 12.243 15 15C15 17.757 12.757 20 10 20C7.243 20 5 17.757 5 15C5 12.243 7.243 10 10 10ZM10 9C6.6865 9 4 11.6865 4 15C4 18.3135 6.6865 21 10 21C13.3135 21 16 18.3135 16 15C16 11.6865 13.3135 9 10 9Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C14.411 7 18 10.589 18 15C18 19.411 14.411 23 10 23C5.589 23 2 19.411 2 15C2 10.589 5.589 7 10 7ZM10 6C5.03 6 1 10.03 1 15C1 19.97 5.03 24 10 24C14.97 24 19 19.97 19 15C19 10.03 14.97 6 10 6Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3531 4.35358L20.646 3.64648L9.646 14.6465L10.3531 15.3536L21.3531 4.35358Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 2.4555V3.5V4.5H21.4999H22.5419C21.8869 5.9455 20.8184 7.62 19.7119 7.62C19.2624 7.62 18.7559 7.3415 18.2069 6.793C17.2194 5.8055 17.3654 5.2105 17.4134 5.015C17.6564 4.0235 19.1334 3.073 20.4999 2.4555ZM21.4999 1C21.4999 1 13.4999 3.5 17.4999 7.5C18.2999 8.3 19.0399 8.62 19.7119 8.62C22.3999 8.62 23.9999 3.5 23.9999 3.5H21.4999V1Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2.5H18.5V6H19.5V2.5Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49988 24C1.37188 24 1.24388 23.951 1.14638 23.8535C0.950881 23.658 0.950881 23.342 1.14638 23.1465L3.28238 21.0105C3.47788 20.815 3.79388 20.815 3.98938 21.0105C4.18488 21.206 4.18488 21.522 3.98938 21.7175L1.85338 23.8535C1.75588 23.951 1.62788 24 1.49988 24Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 24C18.3719 24 18.2439 23.951 18.1464 23.8535L16.0099 21.717C15.8144 21.5215 15.8144 21.2055 16.0099 21.01C16.2054 20.8145 16.5214 20.8145 16.7169 21.01L18.8534 23.1465C19.0489 23.342 19.0489 23.658 18.8534 23.8535C18.7559 23.951 18.6279 24 18.4999 24Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.77900a9302e16c56e5f336757861406f.svg";
export { ForwardRef as ReactComponent };